/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VoucherStatus } from './voucher-status';
import { VoucherProrogaDTO } from './voucher-proroga-dto';
import { VoucherRevocaDTO } from './voucher-revoca-dto';


export interface VoucherDTO { 
    id?: string;
    codice?: string;
    pratica_id?: string;
    codice_pratica?: string;
    tipo_pratica_id?: string;
    nome?: string;
    cognome?: string;
    valore_totale?: number;
    valore_residuo?: number;
    status?: VoucherStatus;
    time_erogazione?: string;
    time_scadenza?: string;
    /**
     * true se timeScadenza < now (scadenza lazy, nessuna transizione di stato)
     */
    scaduto?: boolean;
    nome_file_pdf?: string;
    /**
     * CF ammessi a spendere (interno, per lo spend di Fase D)
     */
    codici_fiscali?: Array<string>;
    /**
     * Nome/i beneficiario (interno, per la disambiguazione di Fase D)
     */
    tag?: string;
    /**
     * true se la revoca e\' consentita dalla policy e dallo stato del voucher. Non anticipa le guardie dipendenti dai dati (rendicontazione, articoli-mode), che rifiutano con 422 alla revoca
     */
    revocabile?: boolean;
    /**
     * Se non revocabile, il motivo come codice stabile: REVOCA_NON_ABILITATA, GIA_REVOCATO, GIA_SPESO (SOLO_NON_SPESO con consumi); null se revocabile
     */
    motivo_non_revocabile?: string;
    /**
     * Registro della revoca attiva; null se il voucher non e\' revocato
     */
    revoca?: VoucherRevocaDTO;
    /**
     * Versione per il lock ottimistico: va rispedita nel body della revoca
     */
    version?: number;
    /**
     * Storico delle proroghe di scadenza, dalla piu\' recente. Presente solo nel dettaglio e nella risposta di proroga (assente in lista); [] se il voucher non e\' mai stato prorogato
     */
    proroghe?: Array<VoucherProrogaDTO>;
    /**
     * true se la revoca attiva si puo\' annullare (D-61): non per BLOCCA_E_STORNA. L\'operazione resta riservata al SUPERADMIN
     */
    revoca_annullabile?: boolean;
    /**
     * Revoche annullate, dalla piu\' recente. Presente solo nel dettaglio; [] se nessuna
     */
    revoche_annullate?: Array<VoucherRevocaDTO>;
}



